export default "/images/ed7cdef0f197db3fc5af54e52735769e.avif";